import { convertRowsToCamelCaseArray, createColumnDefinitions } from "@revbox/helpers-fe";
import { campaignsAndPlaceholdersStatusMap } from "@revbox/common-fe";

export const statusMap = {
     1: "activeRecords",
     2: "pausedRecords",
     3: "inactiveRecords",
     4: "notBiddingRecords",
     0: "total"
};

const changeStatusCounter = (
  response,
  setCountByStatus,
  isInventoryInsightsPage
) => {
  if (typeof setCountByStatus === "function") {
    const newCountByStatus = isInventoryInsightsPage
      ? {
          liveRecords: response.liveRecords,
          draftRecords: response.draftRecords,
          total: response.totalRecords,
        }
      : {
          activeRecords: response.activeRecords,
          inactiveRecords: response.inactiveRecords,
          pausedRecords: response.pausedRecords,
          notBiddingRecords: response.notBiddingRecords,
          total: response.total,
        };

    setCountByStatus(newCountByStatus);
  }
};

export function getServerSideDatasourceSplitted(
  getData,
  currentPeriod,
  previousPeriod,
  colWidths,
  classifiedColumns,
  setColumns,
  setCountByStatus,
  status,
  search,
  customColumns,
  inventoryId,
  sortingParams,
  filter
) {
  const isInventoryInsightsPage = window.location.pathname.includes(
    "/pub/dashboard/inventory/insights"
  );

  return {
    getRows: async (params) => {
      const currentPage = params.api.paginationGetCurrentPage() + 1;
      const response = await getData(
        currentPeriod,
        previousPeriod,
        status,
        search,
        currentPage,
        inventoryId,
        sortingParams,
        filter
      );
      if (response?.success) {
        changeStatusCounter(
          response,
          setCountByStatus,
          isInventoryInsightsPage
        );
        const transformedData = convertRowsToCamelCaseArray(response.data);
        const columnDefs = createColumnDefinitions(
          classifiedColumns,
          customColumns,
          colWidths
        );

        if (columnDefs) {
          setColumns(columnDefs);
        }

        const statusKey = status === null ? "null" : status;
        let rowCount = 0;
        if (!status) {
          rowCount = response.total;
        } else {
          if (isInventoryInsightsPage) {
            rowCount =
              response[
                campaignsAndPlaceholdersStatusMap[
                  statusKey
                ]
              ];
          } else {
            rowCount = response[statusMap[statusKey]];
          }
        }
        params.success({
          rowData: transformedData,
          rowCount: rowCount,
        });
      } else {
        params.fail();
      }
    },
  };
}
